import { render, staticRenderFns } from "./TheOverlay.vue?vue&type=template&id=1f9a7ab6&scoped=true"
import script from "./TheOverlay.vue?vue&type=script&lang=js"
export * from "./TheOverlay.vue?vue&type=script&lang=js"
import style0 from "./TheOverlay.vue?vue&type=style&index=0&id=1f9a7ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a7ab6",
  null
  
)

export default component.exports